import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/illus-home.png'
import _imports_1 from '../../assets/action_purple.svg'


const _hoisted_1 = { class: "space-y-3 pt-8 w-auto rounded h-screen flex items-center bg-gray-200" }
const _hoisted_2 = { class: "container grid justify-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-16 w-24"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl pt-5 text-black" }, "You have not created any jobs yet.", -1)
const _hoisted_5 = { class: "pt-10 pb-6" }
const _hoisted_6 = { class: "text-primary px-4 py-3 rounded-full border-2 border-primary" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", { class: "pl-4" }, "Create new job")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/create-job",
            style: {"text-decoration":"none"}
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}